export default["__VITE_ASSET__BSGn38hE__","__VITE_ASSET__DuwUxfSS__"];